import React, { useContext, useState, Fragment } from 'react';
import context from '../context';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { FacebookFilled, WhatsAppOutlined, InstagramFilled, LinkedinFilled } from '@ant-design/icons';

import RateBar from './ratebar';
import Logo from './logo';
import { NavLink, NavButton } from '../styled-components';

const Header = styled.header`
  background-color: ${props => props.light ? "#fff" : "#00163b"};
  position: absolute;
  top: 0;
  left: 0;
  height: 13rem;
  width: 100%;
  z-index: 500;
`
const Navigation = styled.nav`
  padding: 1rem 0;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  border-bottom: ${props => props.light ? "2px solid #fff" : "2px solid rgba(white)"};
`
const InnerNav = styled.div`
  display: flex;
  align-items: flex-end;
`
const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: ${props => props.horizontal ? "flex" : "block"};
  text-align: center;
`
const NavItem = styled.li`
  
`
const NavLinkCustom = styled(NavLink)`
  color: rgba(white);
  position: relative;
  &:hover{
    color: rgba(white);
  }
`
const NavLinkLine = styled.div`
  position: absolute;
  bottom: -23px;
  left: 0;
  width: 0;
  height: 5px;
  background-color: rgba(white);
  transition: 250ms ease;
  @media(min-width: 768px){
    bottom: -21px;
  }
  @media(min-width: 992px){
    bottom: -23px;
  }  
  ${NavLinkCustom}:hover & {
    background-color: rgba(white);
    width: 100%;
  }
`
const SocialNav = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  li + li{
    margin-left: 1rem;
  }
`
const SocialItem = styled.li`

`
const SocialLink = styled.a`
  transition: 250ms ease;
  color: white;
  &:visited {
    color: white;
  }
  &:hover {
    color: #fff;
  }
  font-size: 25px; /* Ajusta este valor según sea necesario */
`;


export default ({ dark, light })=> {
  const state = useContext(context);

  return(
    <Header className="d-none d-lg-block" light={light}>
      <RateBar /> 
      <Container>
        <Navigation light={light}>
          <InnerNav>
          <AniLink paintDrip hex={state.primaryColor} to="/" duration={.5}>
            <Logo dark={dark} light={!dark} />
          </AniLink>
          <NavList horizontal>
            <NavItem>
              <AniLink paintDrip hex={state.primaryColor} to="/" duration={.5}>
                <NavLinkCustom dark={dark} light={!dark}>
                  Inicio
                  <NavLinkLine />
                </NavLinkCustom>
              </AniLink>            
            </NavItem>            
            <NavItem>
              <AniLink paintDrip hex={state.primaryColor} to="/properties" duration={.5}>
                <NavLinkCustom dark={dark} light={!dark}>
                  Propiedades
                  <NavLinkLine />
                </NavLinkCustom>
              </AniLink>            
            </NavItem>
            <NavItem>
              <AniLink paintDrip hex={state.primaryColor} to="/sales" duration={.5}>
                <NavLinkCustom dark={dark} light={!dark}>
                  Venta
                  <NavLinkLine />
                </NavLinkCustom>
              </AniLink>            
            </NavItem>
            {/* <NavItem>
              <AniLink paintDrip hex="#5E90F2" to="/properties/?status=PUBLICADA,ARRENDADA,VENDIDA&limit=12&typeId=office&id=5e8e36b31c9d440000d35090&propertyType=&operation=ARRIENDO&commune=&stringSearch=&priceMin=&priceMax=&totalAreaFrom=&totalAreaTo=&bedrooms=&bathrooms=&currency=CLP" duration={.5}>
                <NavLinkCustom dark={dark} light={!dark}>
                  Arriendo
                  <NavLinkLine />
                </NavLinkCustom>
              </AniLink>            
            </NavItem>                         */}
            <NavItem>
              <AniLink paintDrip hex={state.primaryColor} to="/about" duration={.5}>
                <NavLinkCustom dark={dark} light={!dark}>
                  Nosotros
                  <NavLinkLine />
                </NavLinkCustom>
              </AniLink>            
            </NavItem>
            <NavItem>
              <AniLink paintDrip hex={state.primaryColor} to="/contact" duration={.5}>
                <NavLinkCustom dark={dark} light={!dark}>
                  Contacto
                  <NavLinkLine />
                </NavLinkCustom>
              </AniLink>                                    
            </NavItem>
            <NavItem>
              <AniLink paintDrip hex={state.primaryColor} to="/contactas" duration={.5}>
                <NavLinkCustom dark={dark} light={!dark}>
                ¿Quieres saber el precio de tu propiedad?
                  <NavLinkLine />
                </NavLinkCustom>
              </AniLink>                                    
            </NavItem>
          </NavList>
          </InnerNav>
          <SocialNav>
            {/*<SocialItem>
              <SocialLink
                rel="noopener"
                target="_blank"
                href="#"
              >
                <FacebookFilled />
              </SocialLink>
          </SocialItem>*/}
            <SocialItem>
              <SocialLink
                rel="noopener"
                target="_blank"
                href={state.instagram}
              >
                <InstagramFilled />
              </SocialLink>
            </SocialItem>
            {/*<SocialItem>
              <SocialLink
                rel="noopener"
                target="_blank"
                href="#"
              >
                <LinkedinFilled />
              </SocialLink>
        </SocialItem>  */}                                  
          </SocialNav>
        </Navigation>
       
      </Container>
    </Header>    
  )
}